import {
  Card,
  Table,
  Pagination,
  Container,
} from "react-bootstrap";
import { useState, useEffect } from "react";
import "../../payment.css";
import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getPayment } from "../../store/slices/user";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";

export default function Payments() {

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const { paymentList, loading } = useSelector((state) => state.user);

  const perPage = 10;
  const [meta, setMeta] = useState({
    total: 0,
    page: 1,
    limit: perPage,
  });

  useEffect(() => {
    dispatch(
      getPayment({
        page: currentPage,
        limit: perPage,
      }),
    ).then((res) => {
      const payload = res.payload || {};

      setMeta({
        total: payload.total || 0,
        page: payload.page || currentPage,
        limit: payload.limit || perPage,
      });
    });
  }, [dispatch, currentPage]);

  const total = meta.total;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const startIndex = (currentPage - 1) * perPage;
  const currentData = paymentList || [];
  const handleExport = () => {
    const exportData = paymentList.map((item, index) => ({
      "Sl No": index + 1,
      "Member Name": item.user?.name || "-",
      "Plan": item.plan?.name || "-",
      "Payment Method": item.gateway || "-",
      "Amount": (item.amount || 0) / 100,
      "Status": item.status || "-",
      "Payment Date": item.createdAt
        ? new Date(item.createdAt).toLocaleString("en-IN")
        : "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(
      file,
      `Payments_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  return (
    <>
      <div className="breadcrumb-bar mb-4">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">
            {" "}
            <IoIosArrowForward size={15} />{" "}
          </span>

          <span className="breadcrumb-link inactive">Payments</span>
        </div>
      </div>

      <Container fluid>
        <div className="page-content">
          <Card className="customtable-card mt-3">
            {/* TABLE */}
            <Card.Body className="d-flex justify-content-end">
              <Button variant="success" onClick={handleExport}>
                Export Excel
              </Button>
            </Card.Body>
            <div className="table-responsive">
              <Table className="custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Member</th>

                    <th>Plan</th>
                    <th>Method</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {currentData.map((d, index) => (
                    <tr key={index}>
                      <td className="index">{index + 1}</td>

                      <td>
                        <div>{d.user?.name}</div>
                      </td>

                      <td>
                        <span className="dur-badge">{d.plan?.name}</span>
                      </td>

                      <td>{d.gateway}</td>
                      <td>
                        {d?.createdAt
                          ? new Date(d.createdAt).toLocaleDateString()
                          : "-"}
                      </td>

                      <td className="subs">{d.amount}</td>

                      <td>
                        <span
                          className={`badge ${d.status === "success"
                            ? "active"
                            : d.status === "pending"
                              ? "trial"
                              : "inactive"
                            }`}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {d.status === "success" && "✔️"}
                          {d.status === "pending" && "⏳"}
                          {d.status === "failed" && "❌"}
                          {d.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="pagination-wrap mx-3">
              <div>
                Showing {total === 0 ? 0 : startIndex + 1} –{" "}
                {Math.min(startIndex + perPage, total)} of {total}
              </div>

              <Pagination className="custom-pagination">
                <Pagination.Prev
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                />

                {[...Array(totalPages)].map((_, i) => (
                  <Pagination.Item
                    key={i}
                    active={i + 1 === currentPage}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </Pagination.Item>
                ))}

                <Pagination.Next
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          </Card>
        </div>
      </Container>
    </>
  );
}
